import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Checkbox } from 'semantic-ui-react';

import TemplateItem from "../TemplateItem/TemplateItem";
import SvgSpinner from "../SvgSpinner/SvgSpinner";
import InputCounter from "../InputCounter/InputCounter";
import "./TemplateForm.scss";

import {
  setTemplateName,
  uploadImageAsync,
  deleteTemplateImage,
  toggleTemplateByDefault,
} from '../../../redux/actions/editTemplate';

const mapStateToProps = state => ({
  ...state.editTemplate,
});

const mapDispatchToProps = dispatch => ({
  setTemplateName: value => dispatch(setTemplateName(value)),
  toggleByDefault: () => dispatch(toggleTemplateByDefault()),
  saveImageOnServer: file => dispatch(uploadImageAsync(file)),
  deleteTemplateImage: () => dispatch(deleteTemplateImage()),
});

class TemplateForm extends Component {
  static propTypes = {
    template: PropTypes.object.isRequired,
    submitText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    edit: PropTypes.bool,
    oldIsDefault: PropTypes.bool.isRequired,
    setTemplateName: PropTypes.func.isRequired,
    toggleByDefault: PropTypes.func.isRequired,
    saveImageOnServer: PropTypes.func.isRequired,
    //Загруженный файл
    fileName: PropTypes.string.isRequired,
    fileLoading: PropTypes.bool.isRequired,
    fileReady: PropTypes.bool.isRequired,
    deleteTemplateImage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    edit: false,
  };

  constructor() {
    super();
    this.state = {
      formWasSent: false,
      fileError: false,
      fileErrorText: 'Загрузите файл',
    }
  }

  onSubmitForm = () => {
    const { onSubmit } = this.props;
    //Обнулим ошибки, если они были
    this.setFileError(false, 'Загрузите файл');
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) onSubmit();
  }

  //Изменить данные ошибки для файла
  setFileError = (value, text) => {
    this.setState({ fileError: value, fileErrorText: text });
  }

  //Валидация формы перед отправкой на сервер
  validateForm = () => {
    const { template } = this.props;
    if ((template.name.length === 0) || (template.name.length > 15)) return true;
    if (template.thumbnail === null) {
      this.setState({ fileError: true });
      return true;
    }
    return false;
  }

  //Начало загрузки изображения и проверки
  onLoadImage(e) {
    const { saveImageOnServer } = this.props;
    this.setFileError(false, 'Загрузите файл');
    const file = e.target.files[0];
    this.currentFile = file;
    const maxFileSize = 78643200; //Размер в байтах, 75Мб, 1Мб = 1024 * 1024
    //Проверим тип и размер файла. Сначала тип
    if ((file.type === 'image/png') || (file.type === 'image/jpeg')) {
        //Теперь проверим размер файла и отобразим ошибку, если он слишком велик
        if (file.size <= maxFileSize) {
          //Если всё хорошо, отправляем картинку на сервер
          saveImageOnServer(file);
        } else {
          this.setFileError(true, 'Размер файла не должен превышать 75 Мб');
        }
    } else {
      return false;
    }
  }

  //Клик по кнопке загрузки файла
  onClickLoadFile = () => {
    document.getElementById('hidden_input_file').click();
  }
  
  render() {
    const {
      template,
      setTemplateName,
      submitText,
      edit,
      oldIsDefault,
      fileName,
      fileLoading,
      fileReady,
      toggleByDefault,
      deleteTemplateImage
    } = this.props;
    const { formWasSent, fileError, fileErrorText } = this.state;

    const btnClass = classnames({
      'btn': true,
      'btn-green': true,
      'long': edit,
    });

    const templateNameError = ((template.name.length === 0) || (template.name.length > 15)) ? true : false;

    const rowNameClass = classnames({
      'form-row': true,
      'error': formWasSent && templateNameError,
    });

    const rowFileClass = classnames({
      'form-row': true,
      'file': true,
      'error': formWasSent && fileError,
    });

    const previewsClass = classnames({
      'previews-wrap': true,
      'isDefault': template.oldIsDefault,
    });

    let errorText = '';
    if (template.name.length === 0) errorText = 'Введите название шаблона';
    if (template.name.length > 15) errorText = 'Превышена максимальная длина названия шаблона';

    return (
      <div className="form-wrap">
        <div className={rowNameClass}>
          <InputCounter
            label="Название шаблона"
            value={template.name}
            onChange={setTemplateName}
            maxLength={15}
          />
          {(formWasSent && templateNameError) ? (
            <div className="input-text">{errorText}</div>
          ) : false}
        </div>
        {/* Загрузка файла */}
        <div className={rowFileClass}>
          {(template.thumbnail !== null) ? (
            <button
              type="button"
              className="input-btn btn-del"
              onClick={() => deleteTemplateImage()}
            />
          ) : (
            <button
              type="button"
              className="btn btn-green load input-btn"
              onClick={() => this.onClickLoadFile()}
            >
              Загрузить
            </button>
          )}
          {/* Невидимый инпут-файл, спрятан под обычный инпут */}
          <input
            id="hidden_input_file"
            className="input-file"
            name="file"
            type="file"
            accept="image/jpeg, image/png"
            onChange={(e) => this.onLoadImage(e)}
          />
          {/* Ложный инпут, где отображается название файла */}
          <div className="input-wrap">
            <div className="input-top">
              <label htmlFor="fileInput">Файл</label>
            </div>
            <input
              type="text"
              name="fileInput"
              value={fileName}
            />
          </div>
          {fileError ? (
            <div className="input-text">{fileErrorText}</div>
          ) : false}
        </div>
        {/* Превью шаблонов или лоадер */}
        <div className={previewsClass}>
          {fileLoading ? (
            <SvgSpinner />
          ) : false}
          {fileReady ? (
            <React.Fragment>
              <TemplateItem
                key={`${template.id}_${1}`}
                template={template}
                type={'trapezoidal'}
              />
              <TemplateItem
                key={`${template.id}_${2}`}
                template={template}
                type={'round'}
              />
              <TemplateItem
                key={`${template.id}_${3}`}
                template={template}
                type={'square'}
              />
            </React.Fragment>
          ) : false}
        </div>
        {/* Использование шаблона по умолчанию, есть только у шаблонов, которые не по умолчанию */}
        {!oldIsDefault ? (
          <div className="form-row special">
            <div className="checkboxes-wrap">
              <Checkbox
                label='Использовать по умолчанию'
                checked={template.is_default}
                onChange={() => toggleByDefault()}
              />
            </div>
          </div>
        ) : false}
        <div className="form-row special">
            <button
              type="button"
              className={btnClass}
              onClick={() => this.onSubmitForm()}
            >
              {submitText}
            </button>
          </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateForm);
